export const routes = {
  oauthtoken: () => "/oauthtoken",
  ClientValidation: (refresh_token) =>`/token/refresh?refresh_token=${refresh_token}`,
  changePassword: () => "/changePassword",
  // Customer roles endpoint
  getCustomerRoles: () => "/customer/roles",
  // OTP-based password reset flow
  sendOTP: () => "/send-otp",
  resendOTP: () => "/resend-otp",
  verifyOTP: () => "/verify-otp",
  setNewPassword: () => "/set-new-password",
  recentEntries: (data) => {
    const params = new URLSearchParams(data);
    return `/recentEntries?${params}`
  },
  attendanceSummary: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/attendanceSummary${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  weeklyAttendanceSummary: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/weeklyAttendanceSummary${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  getLocations: () => "/locations",
  createLocations: () => "/locations",
  editLocations: (id) => `/locations/${id}`,
  deleteLocations: (id) => `/locations/${id}`,
  // Location Settings Routes
  getLocationSettings: () => "/admin/location/settings",
  updateLocationSettings: () => "/admin/location/settings",
  getDepartments: () => "/departments",
  createDepartments: () => "/departments",
  editDepartment: (id) => `/department/${id}`,
  deleteDepartment: (id) => `/department/${id}`,
  getReportTo: () => "/reportingSeniors",
  createReportTo: () => "/reportingSeniors",
  editReportTo: (id) => `/reportingSeniors/${id}`,
  deleteReportTo: (id) => `/reportingSeniors/${id}`,
  getShift: () => "/shifts",
  createShift: () => "/shifts",
  editShift: (id) => `/shifts/${id}`,
  deleteShift: (id) => `/shifts/${id}`,
  getEmployees: () => "/employees",
  getEmployee: (id) => `/employees/${id}`,
  addEmployee: () => "/employees",
  editEmployee: (id) => `/employees/${id}`,
  deleteEmployee: (id) => `/employees/${id}`,
  restoreEmployee: (id) => `/employees/${id}/restore`,
  getArchivedEmployees: (params) => {
    const queryParams = new URLSearchParams(params);
    return `/admin/employees/archived?${queryParams}`;
  },
  getAttendanceReports: (data) => {
    const params = new URLSearchParams(data);
    return `/attendanceReports?${params}`},
  adminAttendanceReports: (data) => {
    const params = new URLSearchParams(data);
    return `/admin/attendance-reports?${params}`},
  triggerAutoClockout: () => "/admin/attendance/auto-clockout/trigger",
  getEmployeesByFilter: (data) => {
    const params = new URLSearchParams(data);
    return `/employees/filter?${params}`
  },
  uploadProfileImg: (cloudName) => `${cloudName}/image/upload`,
  getPayroll: (data) => {
    const params = new URLSearchParams(data);
    return `/payroll-report?${params}`
  },
  getLeave: () => "/leaveRequests",
  approveLeave: () => "/approveLeave",
  recallLeave: () => "/recallLeave",

  // Multi-Branch System API Routes
  // Company Management
  company: () => "/admin/company",
  companyInfo: () => "/admin/company",

  // Branch Management
  branches: () => "/admin/branches",
  branchById: (branchId) => `/admin/branches/${branchId}`,
  branchActivate: (branchId) => `/admin/branches/${branchId}/activate`,
  branchDeactivate: (branchId) => `/admin/branches/${branchId}/deactivate`,

  // User Management
branchUsers: (branchId) => `/admin/branches/${branchId}/users`,
createBranchUser: (branchId) => `/admin/branches/${branchId}/users`,
allUsers: () => "/admin/users",
userTransfer: (userId) => `/admin/users/${userId}/transfer`,
userStatus: (userId) => `/admin/users/${userId}/status`,
deleteUser: (userId) => `/admin/users/${userId}`,
getUserDetails: (userId) => `/admin/users/${userId}`,

  // Admin Cross-Branch Data Access
  adminEmployees: () => "/admin/employees",
  adminCompanyAnalytics: () => "/admin/company-analytics",
  
  // Branch Filtering Routes (for Company Admins)
  adminBranches: () => "/admin/branches",
  adminEmployeesByBranch: (branchId) => `/admin/employees?branch_id=${branchId}`,
  adminAttendanceReportsByBranch: (branchId) => `/admin/attendance-reports?branch_id=${branchId}`,
  adminAnalyticsByBranch: (branchId) => `/admin/company-analytics?branch_id=${branchId}`,

  // Enhanced Employee Management (existing with new response format)
  employees: () => "/employees",
  
  // Bulk Upload Routes
  bulkUploadTemplate: (download = false) => `/employees/bulk-upload-template${download ? '?download=true' : ''}`,
  bulkUpload: () => "/employees/bulk-upload",

  // Plan Management
  getPlanInfo: () => "/api/user/plan-info",

  // AI Analytics Routes
  getRiskAssessment: (params = '') => `/ai/attendance-risk-assessment${params ? `?${params}` : ''}`,
  getAttendancePredictions: (params = '') => `/ai/attendance-predictions${params ? `?${params}` : ''}`,
  getAttendancePatterns: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/ai/attendance-patterns${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  getAnalyticsSummary: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/ai/attendance-summary${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  
  // AI Turnover Prediction Routes
  getTurnoverPredictions: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/turnover/predictions${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  getTurnoverSummary: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/turnover/summary${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  getEmployeeTurnoverPrediction: (employeeId) => `/turnover/employee/${employeeId}`,
  getDepartmentTurnoverInsights: (departmentId) => `/turnover/department/${departmentId}`,

  // NEW: Shift-Based Activity Control Routes
  // Clock-in/out endpoints (mobile)
  clockIn: () => "/clockIn",
  clockOut: (employeeId) => `/clockOut/${employeeId}`,
  clockBreak: () => "/clockBreak",
  
  // NEW: Overtime Reports Routes
  getOvertimeReports: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/overtime/reports${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  getOvertimeSummary: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/overtime/summary${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  
  // NEW: Admin Overtime Reports Routes (with branch filtering)
  getAdminOvertimeReports: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/admin/overtime/reports${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  getAdminOvertimeSummary: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/admin/overtime/summary${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  getAttendanceWithOvertime: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/attendance/overtime${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },

  // NEW: Admin Overtime Management Routes
  getAdminOvertimeSettings: () => "/admin/overtime/settings",
  updateAdminOvertimeSettings: () => "/admin/overtime/settings",
  getAdminOvertimeRequests: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/admin/overtime/requests${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  approveAdminOvertimeRequest: (requestId) => `/admin/overtime/approve/${requestId}`,
  assignAdminOvertime: (employeeId) => `/admin/overtime/assign/${employeeId}`,
  getAdminOvertimeAnalytics: () => "/admin/overtime/analytics",
  getAdminWeeklyOvertimeReports: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/admin/overtime/reports/weekly${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },

  // NEW: Employee Overtime Request Routes
  createOvertimeRequest: () => "/overtime/request",
  getMyOvertimeRequests: () => "/overtime/my-requests",

  // Holidays Management Routes
  getHolidays: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/holidays${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  createHoliday: () => "/holidays",
  getHolidayById: (holidayId) => `/holidays/${holidayId}`,
  updateHoliday: (holidayId) => `/holidays/${holidayId}`,
  deleteHoliday: (holidayId) => `/holidays/${holidayId}`,
  bulkImportHolidays: () => "/holidays/bulk-import",

  // Break Settings Routes
  getBreakSettings: () => "/admin/break-settings",
  updateBreakSettings: () => "/admin/break-settings",
  getEmployeeBreakSettings: (employeeId) => `/admin/employees/${employeeId}/break-settings`,
  updateEmployeeBreakSettings: (employeeId) => `/admin/employees/${employeeId}/break-settings`,

  // Customer Payment Management Routes
  // Subscription Management
  getUserSubscription: () => "/api/user/subscription",
  cancelSubscription: () => "/api/subscription/cancel",
  reactivateSubscription: () => "/api/subscription/reactivate", 
  updateSubscriptionPlan: () => "/api/subscription/update-plan",

  // Payment Methods
  getPaymentMethods: () => "/api/user/payment-methods",
  addPaymentMethod: () => "/api/user/payment-methods/add",
  setDefaultPaymentMethod: (id) => `/api/user/payment-methods/${id}/default`,
  deletePaymentMethod: (id) => `/api/user/payment-methods/${id}`,

  // Billing & Payments
  getUserBilling: () => "/api/user/billing",
  getUserPayments: () => "/api/user/payments",
  getBillingPortal: () => "/api/user/billing/portal",

  // Plans & Usage
  getPlans: () => "/api/plans",
  getPlansCompare: () => "/api/plans/compare",
  getUserUsage: () => "/api/user/usage",
  updatePlanInfo: () => "/api/user/plan-info",
  // getUserProfile: () => "/api/user/profile",
  // updateUserProfile: () => "/api/user/profile",
  deleteAccount: () => "/api/user/delete-account",

  // Productivity Reports Routes
  getEmployeeProductivity: (employeeId, params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/productivity/employee/${employeeId}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  getTeamProductivity: (departmentId, params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/productivity/team/${departmentId}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  getOrganizationProductivity: () => "/productivity/organization",
  getProductivityRanking: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/productivity/ranking${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  calculateProductivityMetrics: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/productivity/metrics/calculate${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },

  // Performance Reports Routes
  getEmployeePerformance: (employeeId, params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/performance/employee/${employeeId}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  getPerformanceRanking: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/performance/ranking${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  getPerformanceInsights: () => "/performance/insights",
  createPerformanceGoal: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/performance/goals${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  getEmployeeGoals: (employeeId, params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/performance/goals/${employeeId}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  updatePerformanceGoal: (goalId) => `/performance/goals/${goalId}`,

  // Enhanced Payroll System Routes
  // Payroll Dashboard
  getPayrollDashboard: () => "/api/payroll/dashboard",
  
  // Company Wallet Management
  getCompanyWallet: () => "/api/payroll/company-wallet",
  fundWallet: () => "/api/payroll/fund-wallet",
  confirmFunding: () => "/api/payroll/confirm-funding",
  verifyAndUpdateFunding: () => "/api/payroll/verify-and-update-funding",
  getPaymentStatus: (txRef) => {
    const queryParams = new URLSearchParams({ tx_ref: txRef });
    return `/api/payroll/payment-status?${queryParams.toString()}`;
  },
  webhookFlutterwave: () => "/api/payroll/webhook/flutterwave",
  getWalletStatus: () => "/api/payroll/wallet/status",
  getFundingHistory: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/api/payroll/funding-history${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  getSettlementBreakdown: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.month) queryParams.append('month', params.month);
    if (params.year) queryParams.append('year', params.year);
    const queryString = queryParams.toString();
    return `/api/wallet/settlement-breakdown${queryString ? `?${queryString}` : ''}`;
  },
  
  // Employee Bank Details (Updated)
  getEmployeeBankDetails: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/api/payroll/employee/bank-details${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  getAllEmployeeBankDetails: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/api/payroll/employee/bank-details/all${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  addEmployeeBankDetails: () => "/api/payroll/employee/bank-details",
  updateEmployeeBankDetails: () => "/api/payroll/employee/bank-details",
  nameEnquiry: () => "/api/payroll/name-enquiry",
  
  // Payroll Deductions System
  getPayrollDeductions: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/api/payroll/deductions${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  createPayrollDeduction: () => "/api/payroll/deductions",
  updatePayrollDeduction: (deductionId) => `/api/payroll/deductions/${deductionId}`,
  deletePayrollDeduction: (deductionId) => `/api/payroll/deductions/${deductionId}`,
  
  // Payroll Allowances System
  getPayrollAllowances: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.allowance_type) queryParams.append('allowance_type', params.allowance_type);
    if (params.month) queryParams.append('month', params.month);
    if (params.year) queryParams.append('year', params.year);
    if (params.is_active !== undefined) queryParams.append('is_active', params.is_active);
    const queryString = queryParams.toString();
    return `/api/payroll/allowances${queryString ? `?${queryString}` : ''}`;
  },
  createPayrollAllowance: () => "/api/payroll/allowances",
  getPayrollAllowance: (allowanceId) => `/api/payroll/allowances/${allowanceId}`,
  updatePayrollAllowance: (allowanceId) => `/api/payroll/allowances/${allowanceId}`,
  deletePayrollAllowance: (allowanceId) => `/api/payroll/allowances/${allowanceId}`,
  
  // Settlement Clearing System
  getTaxAccount: () => "/api/settlement/tax-account",
  setTaxAccount: () => "/api/settlement/tax-account",
  getSettlementSummary: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.batch_id) queryParams.append('batch_id', params.batch_id);
    const queryString = queryParams.toString();
    return `/api/settlement/summary${queryString ? `?${queryString}` : ''}`;
  },
  paySettlementByCategory: () => "/api/settlement/pay-by-category",
  payAllSettlements: () => "/api/settlement/pay-all",
  getSettlementPaymentHistory: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.category_name) queryParams.append('category_name', params.category_name);
    if (params.payment_status) queryParams.append('payment_status', params.payment_status);
    const queryString = queryParams.toString();
    return `/api/settlement/payment-history${queryString ? `?${queryString}` : ''}`;
  },
  
  // Payroll Period Settings
  getPayrollPeriodSettings: () => "/admin/payroll/period-settings",
  updatePayrollPeriodSettings: () => "/admin/payroll/period-settings",
  
  // Funding Calculator
  calculateFundingRequirement: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/api/payroll/calculate-funding-requirement${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  
  // Batch Management (Updated)
  getPayrollBatches: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/api/payroll/batches${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  createPayrollBatch: () => "/api/payroll/batch/initiate",
  updatePayrollBatch: (batchId) => `/api/payroll/batch/${batchId}`,
  deletePayrollBatch: (batchId) => `/api/payroll/batch/${batchId}`,
  getBatchStatus: (batchId) => `/api/payroll/batch/${batchId}/status`,
  getPaymentFlowDetails: (batchId) => `/api/payroll/batch/${batchId}/payment-details`,
  
  // HR Approvals (Updated)
  getPendingHRApprovals: () => "/api/payroll/pending-hr-approvals",
  approveHRBatch: (batchId) => `/api/payroll/batch/${batchId}/hr-approve`,
  rejectHRBatch: (batchId) => `/api/payroll/batch/${batchId}/hr-reject`,
  
  // Accountant Approvals (Updated)
  getPendingAccountantApprovals: () => "/api/payroll/pending-accountant-approvals",
  approveAccountantBatch: (batchId) => `/api/payroll/batch/${batchId}/accountant-approve`,
  rejectAccountantBatch: (batchId) => `/api/payroll/batch/${batchId}/accountant-reject`,
  
  // Payment Execution (NEW!)
  executePayrollPayment: (batchId) => `/api/payroll/execute-payment/${batchId}`,
  
  // Additional missing endpoints from backend
  getFundingPreview: () => "/api/payroll/funding-preview",
  
  // Payment Tracking (Updated)
  getPaymentTracking: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/api/payroll/payment-tracking${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  retryFailedPayments: (batchId) => `/api/payroll/batch/${batchId}/retry-failed-payments`,
  
  // Enhanced Payroll Reports
  getEnhancedPayrollReports: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/payroll-report${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  exportPayrollReport: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/payroll-report/export${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  
  // Utility Routes
  getEmployeesForPayroll: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/api/payroll/employees${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  getPayrollStatistics: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return `/api/payroll/statistics${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  },
  
  // Direct Debit Routes
  setupDirectDebit: () => "/api/payroll/setup-direct-debit",
  getMandateStatus: () => "/api/payroll/mandate-status",
  updatePaymentMethod: () => "/api/payroll/payment-method",
  getPaymentMethod: () => "/api/payroll/payment-method",
};
  